// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__YCWhe","button":"NavBar_button__1p7DU"};